export default function getNewIndex( current, total, delta ) {
	if ( typeof delta === 'boolean' ) {
		delta = delta ? 1 : -1;
	}

	current += delta;
	if ( delta > 0 && current > total - 1 ) {
		current = 0;
	}
	if ( delta < 0 && current < 0 ) {
		current = total - 1;
	}

	return current;
}
